import { createApp, nextTick } from 'vue'
import App from './App.vue'
import router from './router'
import { setupAuthAxios, setupAuthFetch } from './auth'
import { installFrontendRecovery, startFrontendVersionCheck } from './version-check'
import 'element-plus/theme-chalk/el-overlay.css'
import 'element-plus/theme-chalk/el-message-box.css'
import 'element-plus/theme-chalk/el-message.css'

const isBenignResizeObserverError = (message) => (
  String(message || '').includes('ResizeObserver loop completed with undelivered notifications') ||
  String(message || '').includes('ResizeObserver loop limit exceeded')
)

window.addEventListener('error', (event) => {
  if (isBenignResizeObserverError(event?.message)) {
    event.stopImmediatePropagation()
    event.preventDefault()
  }
}, true)

window.addEventListener('unhandledrejection', (event) => {
  if (isBenignResizeObserverError(event?.reason?.message || event?.reason)) {
    event.preventDefault()
  }
})

setupAuthFetch()
setupAuthAxios()
installFrontendRecovery(router)

createApp(App)
  .use(router)
  .mount('#app')

// Wait for page setup so restored carts and page-specific guards are registered.
router.isReady().then(() => nextTick()).then(startFrontendVersionCheck).catch(() => {})
